import React from "react";
import {
  Dialog,
  Button,
  makeStyles,
  Typography,
  Box,
  CircularProgress,
} from "@material-ui/core";
import { getLang } from "app/feature/constants";
import InputTextField from "components/input/inputTextField";
import { Formik } from "formik";

const useStyle = makeStyles((theme) => ({
  root: {
    textAlign: "center",
    padding: "35px 30px",
    backgroundColor: "#ffffff",
    color: "black !important",
    borderRadius: 12,
  },
  customDialogActionRoot: {
    justifyContent: "center",
  },
  customDialogTitle: {
    paddingTop: 0,
    color: "black",
  },
  customDialogPaperWithXs: {
    maxWidth: 360,
  },
  dialogRemarksCaption: {
    fontWeight: 200,
    marginLeft: 5,
  },
  dialogRemarks: {
    color: "#FD646F",
  },
  dangerCancelButton: {
    color: "white",
    borderColor: "white !important",
  },
  successCancelButton: {
    backgroundColor: theme.palette.primary.main,
  },
  dangerText: {
    color: "white",
  },
  successText: {
    color: "white",
  },
  defaultText: {
    color: "black",
  },
}));

export default function RejectConfirmDialogComponent({
  isLoading,
  isOpen,
  handleClose,
  handleProceed,
  lang,
  title,
  description,
}) {
  const classes = useStyle();

  return (
    <Dialog
      classes={{
        paper: classes.root,
        paperWidthXs: classes.customDialogPaperWithXs,
      }}
      open={isOpen}
      disableBackdropClick
      disableEscapeKeyDown
      aria-labelledby="confirmation-dialog"
      maxWidth="xs"
    >
      <Box textAlign="start">
        <Box mb={1.5}>
          <Typography variant="body1">
            <b>{title}</b>
          </Typography>
        </Box>
        <Box mb={2.5}>
          <Typography variant="body2">{description}</Typography>
        </Box>
        <Formik
          initialValues={{
            reasons: "",
          }}
          onSubmit={handleProceed}
        >
          {(formik) => (
            <form onSubmit={formik.handleSubmit}>
              <Box width="100%" mb={3}>
                <InputTextField
                  multiline
                  rows={4}
                  className={classes.textArea}
                  value={formik.values.reasons}
                  placeholder={`${getLang(
                    lang,
                    "placeholder.ENTER_A_REASON"
                  )}...`}
                  onChange={(e) => {
                    formik.setFieldValue("reasons", e.target.value || "");
                  }}
                  disabled={isLoading}
                  InputStyle={{
                    background: "white",
                    border: "1px solid #D0D5DD",
                    flex: 1,
                    borderRadius: 0,
                  }}
                  fullWidth
                />
              </Box>
              {isLoading ? (
                <Box display="flex" justifyContent="center" alignItems="center">
                  <CircularProgress />
                </Box>
              ) : (
                <Box display="flex">
                  <Box mr={2} flex={1}>
                    <Button
                      variant="outlined"
                      onClick={() => {
                        formik.handleReset();
                        handleClose();
                      }}
                      color="primary"
                      style={{ width: "100%" }}
                    >
                      {getLang(lang, "label.CANCEL")}
                    </Button>
                  </Box>
                  <Box flex={1}>
                    <Button
                      color="primary"
                      variant="contained"
                      type="submit"
                      style={{
                        backgroundColor: "#F04438",
                        width: "100%",
                        opacity: !formik.values.reasons.trim() ? 0.5 : 1,
                      }}
                      disabled={!formik.values.reasons.trim()}
                    >
                      {getLang(lang, "label.CONFIRM")}
                    </Button>
                  </Box>
                </Box>
              )}
            </form>
          )}
        </Formik>
      </Box>
    </Dialog>
  );
}
